import React from 'react';
import { HeaderWrapper, HeaderContent  } from './Header.Styles';
import { NavigationSearch } from '../../molecules/NavigationSearch/NavigationSearch';
import { Title } from '../../atoms/Title/Title';
import { useIsDesktopOrLaptop, 
  useIsMiniNotebook, 
  useIsMobileBig, 
  useIsMobileMedium, 
  useIsMobileMini 
  } from '../../../styles/theme'

interface HeaderProps {
  onSearch?: (tag: string) => void; // Prop para repassar o evento de busca
}
const foo = () => {
  console.log('No search function provided');
};

export const Header: React.FC<HeaderProps> = ({ onSearch }) => {
  const isMobileMini = useIsMobileMini();
  const isMobileMedium = useIsMobileMedium();
  const isMobileBig = useIsMobileBig();
  const isMiniNotebook = useIsMiniNotebook();
  const isDesktopOrLaptop = useIsDesktopOrLaptop();

    return (
  <HeaderWrapper 
      isMobileMini={useIsMobileMini()}
      isMobileMedium={useIsMobileMedium()}
      isMobileBig={useIsMobileBig()}
      isMiniNotebook={useIsMiniNotebook()}>
    <HeaderContent 
        isMobileMini={useIsMobileMini()}
        isMobileMedium={useIsMobileMedium()}
        isMobileBig={useIsMobileBig()}
        isMiniNotebook={useIsMiniNotebook()}>
      <Title />
      {(!isMobileMini ) && (
      <NavigationSearch onSearch={onSearch || foo} />)}
    </HeaderContent >
  </HeaderWrapper>
  )
};
